import { render, staticRenderFns } from "./PrazoValidadeAnexoField.vue?vue&type=template&id=02df5637&scoped=true&"
import script from "./PrazoValidadeAnexoField.vue?vue&type=script&lang=js&"
export * from "./PrazoValidadeAnexoField.vue?vue&type=script&lang=js&"
import style0 from "./PrazoValidadeAnexoField.vue?vue&type=style&index=0&id=02df5637&lang=scss&scoped=true&"
import style1 from "./PrazoValidadeAnexoField.vue?vue&type=style&index=1&id=02df5637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02df5637",
  null
  
)

export default component.exports